const legacyPublicBucketBaseUrl = 'https://kach-public.s3.us-east-1.amazonaws.com'

export const publicBucketBaseUrl =
  process.env.NEXT_PUBLIC_KACH_PUBLIC_BUCKET_BASE_URL || legacyPublicBucketBaseUrl
